import { ADUserSearchResult, ISystemUserContactInfoDTO, ISystemUserDetailDTO } from "api/swagger/ApiClient";
import { UserContact } from "model/business-types";

export class BusinessTypesMapping {
  mapADUserToUserContact(dto: ADUserSearchResult): UserContact {
    return {
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      mail: dto.email,
      phone: dto.mobilePhone,
      jobTitle: dto.jobTitle,
      countriesContactEmail: dto.countriesContactEmail
    }
  }

  mapUserDetailToUserContact(dto: ISystemUserDetailDTO): UserContact {
    return {
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      mail: dto.email,
      phone: dto.mobilePhone,
      jobTitle: dto.jobTitle,
      countriesContactEmail: dto.countriesContactEmail
    }
  }

  mapUserToUserContact(dto: ISystemUserContactInfoDTO): UserContact {
    return {
      uniqueid: dto.uniqueId,
      username: dto.loginName,
      name: dto.fullName,
      mail: dto.email,
      phone: dto.mobilePhone,
      jobTitle: dto.jobTitle,
      countriesContactEmail: dto.countriesContactEmail
    }
  }
}
